import {
  GraphQLErrorPagesService,
  ErrorPages,
  Item,
  ComponentRendering,
  HtmlElementRendering,
  LayoutServiceData,
} from "@sitecore-jss/sitecore-jss-nextjs";
import { GraphQLLayoutRouteService } from "./layout-route-service";

export interface FetchErrorPageLayoutParams {
  siteName: string;
  locale: string;
  clientFactory: any;
  retries: number;
}

export const fetchErrorPageLayout = async ({
  siteName,
  locale,
  clientFactory,
  retries,
}: FetchErrorPageLayoutParams): Promise<LayoutServiceData | null> => {
  const errorPagesService = new GraphQLErrorPagesService({
    clientFactory,
    siteName,
    language: locale,
    retries,
  });
  let resultErrorPages: ErrorPages | null = null;

  if (
    process.env.DISABLE_SSG_FETCH?.toLowerCase() !== "true" ||
    siteName === "PDP"
  ) {
    try {
      resultErrorPages = await errorPagesService.fetchErrorPages();
    } catch (error) {
      console.log("Error occurred while fetching error pages");
      console.log(error);
    }
  }

  const layoutData = resultErrorPages?.notFoundPage?.rendered || null;

  if (layoutData) {
    const layoutRequestClient = new GraphQLLayoutRouteService({
      siteName,
      clientFactory,
      retries,
    });

    const layoutRouteData = layoutData?.sitecore?.route?.fields
      ? layoutData?.sitecore?.route?.fields["layout"]
      : [];

    try {
      const layoutPartialDesigns =
        ((layoutRouteData as Item)?.fields["PartialDesigns"] as Array<Item>) ||
        [];

      await Promise.all(
        layoutPartialDesigns.map(async (partialDesign) => {
          const partialLayoutData = await layoutRequestClient.fetchLayoutRoute(
            partialDesign.id?.toString() ?? "",
            locale,
          );

          layoutData?.sitecore?.route?.placeholders["headless-header"].push(
            ...(partialLayoutData.sitecore.route?.placeholders[
              "headless-header"
            ] as Array<ComponentRendering | HtmlElementRendering>),
          );

          layoutData?.sitecore?.route?.placeholders["headless-footer"].push(
            ...(partialLayoutData.sitecore.route?.placeholders[
              "headless-footer"
            ] as Array<ComponentRendering | HtmlElementRendering>),
          );
        }),
      );
    } catch {
      // Error handling is intentionally empty
    }
  }

  return layoutData;
};
